import { PropsWithChildren, useEffect } from 'react'

interface Props extends PropsWithChildren {
  show: boolean
  mainContainerClassname?: string
}

const Modal = ({ show, mainContainerClassname, children }: Props) => {
  useEffect(() => {
    if (show) document.body.style.overflowY = 'hidden'
    return () => {
      document.body.style.overflowY = 'auto'
    }
  }, [show])

  return (
    <>
      {show ? (
        <section>
          <div className="fixed inset-0	bg-neutral-70 z-50 opacity-80" />
          <div
            className={`fixed top-1/2 left-4 right-4 -translate-y-1/2 bg-white p-6 flex flex-col z-50 justify-between items-center gap-4 rounded-2xl ${mainContainerClassname}`}
          >
            {children}
          </div>
        </section>
      ) : null}
    </>
  )
}

export default Modal
